import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    name: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    isHome: PropTypes.bool,
    selected: PropTypes.bool,
    count: PropTypes.number,
};

const defaultProps = {
    name: '',
    isHome: false,
    selected: false,
    count: 0,
};

function ChannelListItem(props) {
    let className = "nav-list-item channel";
    if (props.isHome) {
        className += " home";
    }

    if (props.selected) {
        className += " selected";
    }

    return (
        <div
            onClick={props.onClick}
            className={className}
            style={{ cursor: "pointer" }}
        >
            <div className="channelName">{props.name}</div>
            <div className={props.count > 0 ? "count" : "count zero"}>
                {props.count}
            </div>
        </div>
    );
}

ChannelListItem.propTypes = propTypes;
ChannelListItem.defaultProps = defaultProps;

export default ChannelListItem;
